// src/components/elements/Garden.js
import React from 'react';
import './GardenStyles.css';

export const Garden = ({ x, y, width, height, color, type, properties, onDelete }) => {
  const renderTrees = () => {
    const treeCount = Math.floor((width * height) / 5000);
    return Array(treeCount).fill().map((_, i) => {
      const treeX = Math.random() * (width - 20);
      const treeY = Math.random() * (height - 20);
      const treeSize = 15 + Math.random() * 10;
      
      return (
        <g key={`tree-${i}`} transform={`translate(${treeX},${treeY})`}>
          <path
            className="tree-crown"
            d={`
              M ${treeSize/2},0 
              L ${treeSize},${treeSize} 
              L 0,${treeSize} Z
            `}
          />
          <rect
            className="tree-trunk"
            x={treeSize/2 - 2}
            y={treeSize}
            width="4"
            height="8"
          />
        </g>
      );
    });
  };

  const renderWater = () => {
    if (!properties.hasWaterFeature && type !== 'Eco-Pond' && type !== 'Community Lake') {
      return null;
    }

    return (
      <g className="water-feature">
        <defs>
          <pattern id="waterPattern" patternUnits="userSpaceOnUse" width="20" height="20">
            <path
              d="M0 10 Q 5 0, 10 10 T 20 10"
              fill="none"
              stroke="rgba(255,255,255,0.3)"
              strokeWidth="1"
            />
          </pattern>
        </defs>
        <ellipse
          cx={width * 0.5}
          cy={height * 0.5}
          rx={width * 0.3}
          ry={height * 0.3}
          className="water-body"
        />
        <ellipse
          cx={width * 0.5}
          cy={height * 0.5}
          rx={width * 0.3}
          ry={height * 0.3}
          fill="url(#waterPattern)"
          className="water-pattern"
        />
      </g>
    );
  };

  const renderPaths = () => {
    if (!properties.hasWalkways) return null;

    return (
      <g className="walkways">
        <path
          d={`
            M ${width * 0.2},${height * 0.2}
            Q ${width * 0.5},${height * 0.5} ${width * 0.8},${height * 0.8}
            M ${width * 0.2},${height * 0.8}
            Q ${width * 0.5},${height * 0.5} ${width * 0.8},${height * 0.2}
          `}
          className="path"
        />
        <path
          d={`
            M ${width * 0.2},${height * 0.2}
            Q ${width * 0.5},${height * 0.5} ${width * 0.8},${height * 0.8}
            M ${width * 0.2},${height * 0.8}
            Q ${width * 0.5},${height * 0.5} ${width * 0.8},${height * 0.2}
          `}
          className="path-border"
        />
      </g>
    );
  };

  const renderDecorations = () => {
    if (type !== 'Art Park') return null;

    return Array(3).fill().map((_, i) => (
      <g key={`art-${i}`} className="art-installation" transform={`translate(${width * (0.3 + i * 0.2)}, ${height * 0.5})`}>
        <circle r="12" className="art-base" />
        <path
          d="M-6,-6 L6,6 M-6,6 L6,-6"
          className="art-sculpture"
          strokeWidth="2"
        />
      </g>
    ));
  };

  const renderGrass = () => (
    <rect
      width={width}
      height={height}
      fill={color}
      className="grass-base"
    />
  );

  return (
    <div className="garden" style={{ position: 'absolute', left: x, top: y, width, height }}>
      <svg width="100%" height="100%" viewBox={`0 0 ${width} ${height}`}>
        {renderGrass()}
        {renderPaths()}
        {renderWater()}
        {renderTrees()}
        {renderDecorations()}
      </svg>
      
      <div className="garden-label">
        <span className="garden-type">{type}</span>
        {properties.isProtected && <span className="protected-badge">🛡️</span>}
      </div>

      <button 
        className="delete-button"
        onClick={(e) => { e.stopPropagation(); onDelete(); }}
      >
        ×
      </button>
    </div>
  );
};